module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-spin-up@2x.png?0.0.53";